var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsaGaKeno(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    width: 40,
    height: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.198 64.696c-3.755 3.802-3.181 15.123-12.036 17.212h-3.755c5.091-5.279 5.533-12.149.659-17.212H9.333c-2.927 0-5.326-2.418-5.326-5.364V44.473c0-2.945 2.4-5.364 5.326-5.364h81.335c2.927 0 5.326 2.418 5.326 5.364v14.859c0 2.945-2.4 5.364-5.326 5.364h-42.47z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.794 39.73h80.422c2.785 0 5.072 2.296 5.072 5.1v14.135a5.1 5.1 0 0 1-5.072 5.091H48.301c-4.272 1.816-3.454 15.104-12.262 17.4l-2.607.038c4.639-4.366 5.195-13.551-.301-17.438H9.794c-2.785 0-5.072-2.296-5.072-5.091V44.831c0-2.804 2.287-5.1 5.072-5.1z",
    fill: "#c91d2c"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.288 45.075h5.364v5.402l4.677-5.402h5.373l-5.119 6.456 5.75 7.161h-6.004l-4.677-5.91v5.91h-5.364zm43.655 0h5.364v13.617h-5.364l-5.994-5.693v5.693h-5.373V45.075h5.317l6.051 5.533zm-25.841 0h12.356v3.312h-6.474v1.619h6.474v3.237h-6.474v2.136h6.474v3.312c-4.122 0-8.234-.009-12.356-.009V45.075zm49.48 6.427c.075 9.57-17.231 9.617-17.193-.047.028-9.269 17.118-9.166 17.193.047zm-5.891.075c.028 3.727-5.43 3.745-5.42-.019.019-3.614 5.402-3.576 5.42.019z",
    fill: "#fbe543"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M82.32 54.288h4.856V58.4H82.32zm.019-9.768h4.837v4.414l-1.045 4.856h-2.767l-1.026-4.856z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsaGaKeno);
export default __webpack_public_path__ + "static/media/usa_ga_keno.9a0a15c433b38b62192a8966085a57ad.svg";
export { ForwardRef as ReactComponent };